import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=65d99a8b&scoped=true&"
import script from "./BusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&id=65d99a8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d99a8b",
  null
  
)

export default component.exports